<template>
  <v-dialog v-model="modal_move" width="500">
    <v-card>
      <v-card-title class="primary py-2 pr-2 white--text">
        <div class="d-flex justify-space-between align-center w-full">
          <div>
            <v-icon class="mr-2" color="white">mdi-folder-upload-outline</v-icon>
            Move
          </div>
          <v-btn icon>
            <v-icon @click="modal_move = false">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <div class="pa-2 mt-3">
        <p class="text-center">
          Move {{ selected_items_length }} item{{ selected_items_length > 1 ? "s" : "" }} to
        </p>
        <ParentSelector v-model="form_move_location" tabindex="1" />

        <v-btn
          block
          x-large
          color="primary"
          class="mt-10"
          :loading="form_move_loading"
          @click="$store.dispatch('submitMove')"
          tabindex="2"
          outlined
          >move</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ParentSelector from "./ParentSelector";
export default {
  name: "ModalFolder",
  components: { ParentSelector },
  data() {
    return {};
  },
  computed: {
    modal_move: {
      get() {
        return this.$store.state.form_move.modal;
      },
      set(value) {
        this.$store.commit("updateStateFormMove", { modal: value });
      },
    },
    form_move_location: {
      get() {
        return this.$store.state.form_move.location;
      },
      set(value) {
        console.log("here");
        this.$store.commit("updateStateFormMove", { location: value });
      },
    },
    form_move_loading() {
      return this.$store.state.form_move.loading;
    },
    selected_items_length() {
      return this.$store.getters.selected_items.length;
    },
  },
};
</script>
